/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {BaseInstance} from './base-instance';
import {Service} from './service';

export class ServiceInstance extends BaseInstance {
  service: Service;
}
